<template>
  <div>
    <serviceList
      :bannerUrl="bannerUrl"
      :bannerTitle="$t('visualPlatformPage.bannerTitle')"
      :bannerText="$t('visualPlatformPage.bannerText')"
      :characterList="characterList"
      :imgTextList="imgTextList"
      isRightPostion
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/banner-visual-platform.png');
const characterList = [
  {
    img: require('@assets/icons/ico-visual-platform_1.svg'),
    title: t('visualPlatformPage.feature1.title'),
    text: t('visualPlatformPage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-visual-platform_2.svg'),
    title: t('visualPlatformPage.feature2.title'),
    text: t('visualPlatformPage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-visual-platform_3.svg'),
    title: t('visualPlatformPage.feature3.title'),
    text: t('visualPlatformPage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/visual_platform_1.png'),
    title: t('visualPlatformPage.description1.title'),
    text: t('visualPlatformPage.description1.text'),
  },
  {
    img: require('@assets/images/visual_platform_2.png'),
    title: t('visualPlatformPage.description2.title'),
    text: t('visualPlatformPage.description2.text'),
  },
]
</script>